import { richTextResolver } from "@website-builder/utilities/utils/TransformerHelpers.js";
import { isBusinessVerticalB2U } from "@website-builder/utilities/utils/helpers.js";

export default (props, { globalVariableWithUrl = [] }) => {
	const isB2U = isBusinessVerticalB2U();
	const {
		programInfoCard = [],
		hasBoxShadow = false,
		description = "",
	} = props;
	let fetchApiUrl = "";
	const shortName = programInfoCard?.[0]?.shortName;
	if (isB2U) {
		const apiBaseUrl = process.env.GATSBY_API_BASE_URL;
		const workshopEnrollmentDetailsUrl = `${apiBaseUrl}/workshops/microsite/workshop-enrollment-details/`;
		fetchApiUrl = `${workshopEnrollmentDetailsUrl}${shortName}/`;
	} else {
		const enrollmentApiStub = "/workshops/api/workshop-enrollment-details/";
		const apiStubWithSlug = shortName
			? `${enrollmentApiStub}${shortName.replace("/", "")}`
			: `${enrollmentApiStub}${slug}`;
		fetchApiUrl = `${apiBaseUrl}${apiStubWithSlug}`;
	}
	return {
		...props,
		programInfoProps: programInfoCard?.[0] || {},
		fetchApiUrl,
		hasBoxShadow,
		description: richTextResolver(description, globalVariableWithUrl),
	};
};
